/*
 * DocumentList Messages
 *
 * This contains all the text for the DocumentList component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'app.components.DocumentList.title',
    defaultMessage: 'Documents',
  },
  titleWithName: {
    id: 'app.components.DocumentList.titleWithName',
    defaultMessage: '{name}',
  },
  colHeaderType: {
    id: 'app.components.DocumentList.colHeaderType',
    defaultMessage: 'Type',
  },
  colHeaderName: {
    id: 'app.components.DocumentList.colHeaderName',
    defaultMessage: 'Name',
  },
  colHeaderLastModified: {
    id: 'app.components.DocumentList.colHeaderLastModified',
    defaultMessage: 'Last modified',
  },
  colHeaderAuthor: {
    id: 'app.components.DocumentList.colHeaderAuthor',
    defaultMessage: 'Author',
  },
  colHeaderPurpose: {
    id: 'app.components.DocumentList.colHeaderPurpose',
    defaultMessage: 'Purpose',
  },
  colHeaderDeleted: {
    id: 'app.components.DocumentList.colHeaderDeleted',
    defaultMessage: 'Expires',
  },
  colHeaderActions: {
    id: 'app.components.DocumentList.colHeaderActions',
    defaultMessage: 'Actions',
  },
  noDocumentsYet: {
    id: 'app.components.DocumentList.noDocumentsYet',
    defaultMessage: 'No documents stored yet.',
  },
  documentActions: {
    id: 'app.components.DocumentList.documentActions',
    defaultMessage: 'Actions for document {documentName}',
  },
  folderActions: {
    id: 'app.components.DocumentList.folderActions',
    defaultMessage: 'Actions for folder {folderName}',
  },
  deleteAction: {
    id: 'app.components.DocumentList.deleteAction',
    defaultMessage: 'Delete {name}',
  },
  renameAction: {
    id: 'app.components.DocumentList.renameAction',
    defaultMessage: 'Rename {name}',
  },
  createDocumentOrFolder: {
    id: 'app.components.DocumentList.createDocumentOrFolder',
    defaultMessage: 'Create document or directory',
  },
  createDocument: {
    id: 'app.components.DocumentList.createDocument',
    defaultMessage: 'Upload a new document',
  },
  createFolder: {
    id: 'app.components.DocumentList.createFolder',
    defaultMessage: 'Create a new directory',
  },
  gotoParentFolder: {
    id: 'app.components.DocumentList.gotoParentFolder',
    defaultMessage: 'Back to parent directory',
  },
  deleteFolder: {
    id: 'app.components.DocumentList.deleteFolder',
    defaultMessage: 'Delete directory',
  },
  deleteFolderSuccess: {
    id: 'app.components.DocumentList.deleteFolderSuccess',
    defaultMessage: 'Folder successfully deleted',
  },
  deleteFolderFailure: {
    id: 'app.components.DocumentList.deleteFolderFailure',
    defaultMessage: 'Error. Folder deletion failed.',
  },
  deleteFolderConfirmTitle: {
    id: 'app.components.DocumentList.deleteFolderConfirmTitle',
    defaultMessage: 'Delete {folderName}',
  },
  deleteFolderConfirmText: {
    id: 'app.components.DocumentList.deleteFolderConfirmText',
    defaultMessage: 'Should the folder be permanently deleted?',
  },
  deleteNonEmptyFolderConfirmText: {
    id: 'app.components.DocumentList.deleteNonEmptyFolderConfirmText',
    defaultMessage:
      'Attention: This folder is not empty! Do you still want to delete it and all its contents?',
  },
  deleteFolderConfirmDelete: {
    id: 'app.components.DocumentList.deleteFolderConfirmDelete',
    defaultMessage: 'Yes, delete the folder',
  },
  deleteFolderConfirmCancel: {
    id: 'app.components.DocumentList.deleteFolderConfirmCancel',
    defaultMessage: 'No, keep the folder',
  },
  deleteDocument: {
    id: 'app.components.DocumentList.deleteDocument',
    defaultMessage: 'Delete document',
  },
  deleteDocumentSuccess: {
    id: 'app.components.DocumentList.deleteDocumentSuccess',
    defaultMessage: 'Document successfully deleted',
  },
  deleteDocumentFailure: {
    id: 'app.components.DocumentList.deleteDocumentFailure',
    defaultMessage: 'Error. Document deletion failed.',
  },
  deleteDocumentConfirmTitle: {
    id: 'app.components.DocumentList.deleteDocumentConfirmTitle',
    defaultMessage: 'Delete {documentName}',
  },
  deleteDocumentConfirmText: {
    id: 'app.components.DocumentList.deleteDocumentConfirmText',
    defaultMessage: 'Should the document be permanently deleted?',
  },
  deleteDocumentConfirmDelete: {
    id: 'app.components.DocumentList.deleteDocumentConfirmDelete',
    defaultMessage: 'Yes, delete the document',
  },
  deleteDocumentConfirmCancel: {
    id: 'app.components.DocumentList.deleteDocumentConfirmCancel',
    defaultMessage: 'No, keep the document',
  },
  renameFolder: {
    id: 'app.components.DocumentList.renameFolder',
    defaultMessage: 'Rename directory',
  },
  renameFolderDialogTitle: {
    id: 'app.components.DocumentList.renameFolderDialogTitle',
    defaultMessage: 'Rename directory',
  },
  renameDocument: {
    id: 'app.components.DocumentList.renameDocument',
    defaultMessage: 'Rename document',
  },
  renameDocumentDialogTitle: {
    id: 'app.components.DocumentList.renameDocumentDialogTitle',
    defaultMessage: 'Rename',
  },
  renameDocumentDialogPrompt: {
    id: 'app.components.DocumentList.renameDocumentDialogPrompt',
    defaultMessage: 'Please enter the new name for {documentName}.',
  },
  renameDocumentDialogNewName: {
    id: 'app.components.DocumentList.renameDocumentDialogNewName',
    defaultMessage: 'New name:',
  },
  renameDocumentDialogConfirmRename: {
    id: 'app.components.DocumentList.renameDocumentDialogConfirmRename',
    defaultMessage: 'Rename',
  },
  renameDocumentDialogConfirmCancel: {
    id: 'app.components.DocumentList.renameDocumentDialogConfirmCancel',
    defaultMessage: 'Keep the name',
  },
  renameDocumentDialogSuccess: {
    id: 'app.components.DocumentList.renameDocumentDialogSuccess',
    defaultMessage: 'Document successfully renamed',
  },
  renameDocumentDialogFailure: {
    id: 'app.components.DocumentList.renameDocumentDialogFailure',
    defaultMessage: 'Error. Renaming failed.',
  },
  renameFolderDialogSuccess: {
    id: 'app.components.DocumentList.renameFolderDialogSuccess',
    defaultMessage: 'Folder successfully renamed',
  },
  renameFolderDialogFailure: {
    id: 'app.components.DocumentList.renameFolderDialogFailure',
    defaultMessage: 'Error. Renaming failed.',
  },
  purposePublicInformation: {
    id: 'app.components.DocumentList.purposePublicInformation',
    defaultMessage: 'Public information',
  },
  purposeTeamLeaderInformation: {
    id: 'app.components.DocumentList.purposeTeamLeaderInformation',
    defaultMessage: 'Confidential',
  },
  purposeVipInformation: {
    id: 'app.components.DocumentList.purposeVipInformation',
    defaultMessage: 'Confidential',
  },
  purposeUploadTeamLeader: {
    id: 'app.components.DocumentList.purposeUploadTeamLeader',
    defaultMessage: 'Upload',
  },
  purposeCoordinationTeamExchange: {
    id: 'app.components.DocumentList.purposeCoordinationTeamExchange',
    defaultMessage: 'Conf. exchange',
  },
});
